import type { ThunkDispatchType } from '../../redux/types';

import { getBrowserTabId } from 'app/lib/browserTabId';
import { login, logout, reLogin } from 'app/redux/actions/auth';

// ---

const AUTH_CHANNEL_STORAGE_KEY = 'auth-channel';
const LOGOUT_MESSAGE = 'LOGOUT_MESSAGE';
const LOGIN_MESSAGE = 'LOGIN_MESSAGE';

// ---

export const initAuthChannel = () => (dispatch: ThunkDispatchType) => {
  window.addEventListener('storage', (event: StorageEvent) => {
    if (!event.key?.startsWith(AUTH_CHANNEL_STORAGE_KEY) || event.newValue === null) {
      return;
    }

    const tabId = event.key.split('__')[1];

    if (isTabInitiatorEvent(tabId)) {
      return;
    }

    switch (event.newValue) {
      case LOGIN_MESSAGE:
        dispatch(reLogin());
        break;

      case LOGOUT_MESSAGE:
        dispatch(logout());
        break;

      default:
        console.error(`authChannel:message: unknown message type ${event.newValue}`);
        break;
    }

    removeAuthChannelFromStorage(event.key);
  });
};

function isTabInitiatorEvent(tabIdFromStorage: string) {
  return getBrowserTabId() === tabIdFromStorage;
}

function getStorageKey() {
  const tabId = getBrowserTabId();

  return `${AUTH_CHANNEL_STORAGE_KEY}__${tabId}`;
}

function removeAuthChannelFromStorage(key: string) {
  localStorage.removeItem(key);
}

function saveAuthDataToStorage(messageType: string) {
  localStorage.setItem(getStorageKey(), messageType);
}

// ---

export const logoutAllTabs = () => async (dispatch: ThunkDispatchType) => {
  await dispatch(logout());

  saveAuthDataToStorage(LOGOUT_MESSAGE);
};

type User = {
  username: string;
  password: string;
  requestId?: string;
};

export const loginAllTabs = (user: User) => async (dispatch: ThunkDispatchType) => {
  await dispatch(login(user));

  saveAuthDataToStorage(LOGIN_MESSAGE);
};
